import './style.css'
import {Link} from "react-router-dom";

export function ErrorNotFound() {
    return (
        <div>
            <div className="ambient-light-bg">
                <div className="light-orb orb-1"></div>
                <div className="light-orb orb-2"></div>
                <div className="light-orb orb-3"></div>
            </div>
            <div className="relative min-h-screen flex flex-col items-center justify-center p-6">
                <div className="w-full max-w-md animate-[fadeIn_0.5s_ease-out]">
                    <div className="glass-panel rounded-3xl p-1 overflow-hidden shadow-2xl shadow-primary/10">
                        <div
                            className="bg-black/20 rounded-[20px] p-10 flex flex-col items-center justify-center text-center relative overflow-hidden">
                            <div
                                className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
                            <div
                                className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                            <div
                                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-primary/20 blur-[90px] rounded-full pointer-events-none animate-pulse-glow"></div>
                            <h1 className="text-8xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white to-white/10 drop-shadow-sm mb-2 relative z-10 text-glow py-3">
                                404
                            </h1>
                            <div className="space-y-3 z-10 mb-8 max-w-xs mx-auto">
                                <h2 className="text-xl font-medium text-white tracking-tight">Page Not Found</h2>
                                <p className="text-sm text-slate-400 leading-relaxed">
                                    Sorry, the page you are looking for could not be found.
                                </p>
                            </div>
                            <div className="z-10 w-full">
                                <Link className="group relative flex items-center justify-center w-full overflow-hidden rounded-xl bg-primary/90 px-6 py-3.5 font-semibold text-white shadow-[0_0_20px_rgba(19,91,236,0.2)] transition-all hover:bg-primary hover:shadow-[0_0_30px_rgba(19,91,236,0.4)] hover:-translate-y-0.5 active:translate-y-0"
                                   to={"/"}>
                                    <div
                                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:animate-[shimmer_1.5s_infinite]"></div>
                                    <span
                                        className="material-symbols-outlined text-[20px] mr-2 transition-transform group-hover:-translate-x-1">arrow_back</span>
                                    <span>Go Back Home</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

